import React, { useEffect, useMemo, useState } from "react";
import AlumnoLayout from "@/components/AlumnoLayout";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Bell } from "lucide-react";

export default function Notificaciones() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all"); // all | unread | read

  useEffect(() => { load(); }, []);
  const load = () => api.get("/alumno/notifications").then((r) => setItems(r.data));

  const filtered = useMemo(() => items.filter((n) =>
    filter === "all" ? true : filter === "unread" ? !n.read_at : !!n.read_at
  ), [items, filter]);

  const markRead = async (id) => {
    try { await api.post(`/alumno/notifications/${id}/read`); load(); } catch {}
  };

  const unreadCount = items.filter((n) => !n.read_at).length;

  return (
    <AlumnoLayout user={user}>
      <div>
        <p className="text-xs uppercase tracking-widest text-[#93C5FD] font-semibold">Notificaciones</p>
        <h1 className="mt-2 text-3xl font-bold text-white font-display">Tu feed</h1>
        <p className="mt-2 text-gray-400">{unreadCount} sin leer</p>

        <div className="mt-6 inline-flex bg-[#111827] border border-gray-800 rounded-md p-0.5">
          {["all", "unread", "read"].map((f) => (
            <button key={f} onClick={() => setFilter(f)} data-testid={`notif-filter-${f}`}
              className={`px-3 py-1.5 text-xs rounded ${filter === f ? "bg-white/10 text-white" : "text-gray-400 hover:text-white"}`}>
              {f === "all" ? "Todas" : f === "unread" ? "No leídas" : "Leídas"}
            </button>
          ))}
        </div>

        <div className="mt-6 space-y-2" data-testid="notifications-list">
          {filtered.length === 0 && (
            <div className="p-6 border border-dashed border-gray-800 rounded-xl text-gray-400 text-sm text-center">
              Sin notificaciones.
            </div>
          )}
          {filtered.map((n) => (
            <div key={n.id} className={`p-4 rounded-lg border ${n.read_at ? "border-gray-800 bg-[#0F172A]" : "border-[#B84A0C]/50 bg-[#111827]"} flex items-start gap-3`}>
              <div className={`w-2 h-2 rounded-full mt-2 ${n.read_at ? "bg-gray-600" : "bg-[#3B82F6]"}`} />
              <div className="flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <p className="text-white font-semibold">{n.title}</p>
                  <span className="text-[10px] uppercase tracking-widest text-gray-500 font-mono">{n.type}</span>
                </div>
                <p className="text-sm text-gray-400 mt-1">{n.body}</p>
                <p className="text-[11px] text-gray-500 font-mono mt-1">{new Date(n.created_at).toLocaleString("es-MX")}</p>
              </div>
              {!n.read_at && (
                <button onClick={() => markRead(n.id)} data-testid={`notif-read-${n.id}`}
                  className="text-xs text-[#93C5FD] hover:text-white">
                  Marcar leída
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </AlumnoLayout>
  );
}
